import type { NotificationStatus, NotificationPeriodicity } from '@/shared/lib';

export interface NotificationFilterFormData {
  periodicity: NotificationPeriodicity | null;
  status: NotificationStatus | null;
  startDate: Date | null;
  endDate: Date | null;
  customPeriodicity: number | null;
  customPeriodicityUnit: string;
  createdBy: number | null;
}

export type NotificationSearchType = 'notifications' | 'recipient';

export type NotificationItemsPerPage = 10 | 25 | 50 | 'all';

export const NOTIFICATION_QUANTITY_OPTIONS: Array<{
  id: NotificationItemsPerPage;
  name: string;
}> = [
  { id: 10, name: '10 por página' },
  { id: 25, name: '25 por página' },
  { id: 50, name: '50 por página' },
  { id: 'all', name: 'Todas as notificações' },
];
